import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JobPriorityText, JobPriorityVal } from 'src/app/core/models/job';
import { JobsService } from 'src/app/core/services/jobs.service';
import { AuthenticationService } from '../../../../../core/services/authentication.service';
import { UserService } from '../../../../../core/services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-job-priority-dialog',
  templateUrl: './job-priority-dialog.component.html',
  styleUrls: ['./job-priority-dialog.component.scss']
})
export class JobPriorityDialogComponent implements OnInit {

	priorities: string[] = [];
  jobForm: UntypedFormGroup;
  currentLoggedInUser = this.authenticationService.currentUserValue.username;
  depName: string = this.data.depName;

	constructor(
		public dialog: MatDialogRef<JobPriorityDialogComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			depName: string;
			jobName: string;
			actionText: string;
			actionValue: any;
      currPriority: string;
    },
    public jobService: JobsService,
    public userService: UserService,
    private authenticationService: AuthenticationService,
    private _snackBar: MatSnackBar,
		private _spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.updatePriority();
		this.jobForm = new UntypedFormGroup({
			job_Priority: new UntypedFormControl(
				Validators.required
			),
		});
	}

  updatePriority() {
    let priorityVal;

    this.userService.getJobPriority(this.currentLoggedInUser, this.depName)
      .subscribe({
        next: (data: any) => {
          if (data != null) {
            priorityVal = data.jobPro;
            for (let i = priorityVal; i <= 4; i++) {
              if (i === JobPriorityVal.Normal) {
                this.priorities.push(JobPriorityText.Normal);
              }
              if (i === JobPriorityVal.AboveNormal) {
                this.priorities.push(JobPriorityText.AboveNormal);
              }
              if (i === JobPriorityVal.BelowNormal) {
                this.priorities.push(JobPriorityText.BelowNormal);
              }
              if (i === JobPriorityVal.Highest) {
                this.priorities.push(JobPriorityText.Highest);
              }
              if (i === JobPriorityVal.Lowest) {
                this.priorities.push(JobPriorityText.Lowest);
              }
            }
          }
          else {
            this.priorities.push(JobPriorityText.Normal);
          }
          this.jobForm.controls['job_Priority'].setValue(
            this.data.currPriority
          );
        },
        error: (err) => {
          this.priorities.push(JobPriorityText.Normal);
          this.jobForm.controls['job_Priority'].setValue(
            this.priorities[0]
          );
        }
      })
  }

	onCancel() {
		this.dialog.close();
	}

	onSubmit(form) {
    this._spinner.show("jobPriority");
		if (this.jobForm.value.job_Priority !== null) {
			try {
				let newPriority = this.jobForm.value.job_Priority;
				this.jobService.triggerAnActionForJob(
					this.data.depName,
					this.data.jobName,
					this.data.actionText,
					this.data.actionValue,
					"false",
					newPriority,
					""
				).subscribe(() => {
          this._spinner.hide("jobPriority");
					this._snackBar.open('Job priority updated successfully', 'OK', {
						duration: 3000,});
					this.dialog.close(true);
				});
				this.dialog.close();
			} catch (e) {
        this._spinner.hide("jobPriority");
				this._snackBar.open('Error in updating job priority', 'OK', {
					duration: 3000,});
				this.dialog.close(false);
			}
		} else {
			form.controls.job_Priority.touched = true;
		}
	}
}
